<div class="d-flex flex-column">
	<label class="text-center text-tertiary fw-semibold w-100">
		Totais e desvios mensais e anuais (mm) - {{ periodoTitulo }}
	</label>
	<div
		*ngIf="carregandoRelatorio; else tabela"
		class="d-flex justify-content-center align-items-center w-100 h-50"
		style="min-height: 500px">
		<seira-loading [pageCentered]="false" />
	</div>
	<ng-template #tabela>
		<div
			style="max-width: 1300px"
			*ngIf="dadosTabelaRelatorio.length; else semDados">
			<div class="row mt-3 mb-5">
				<div class="mb-2" *ngFor="let relatorio of dadosTabelaRelatorio">
					<label
						for="tabela-precipitacao-do-estado"
						class="text-tertiary mb-2 fw-semibold">
						{{ 'Microrregião ' + relatorio.nomeMicrorregiao }}
					</label>
					<seira-public-table
						#tabelaDesviosMensaisAnuais
						id="tabela-precipitacao-do-estado"
						[hasFooter]="false"
						[hasHeader]="false"
						[info]="false"
						[paging]="false"
						[searching]="false"
						[columns]="colunas"
						[scrollX]="true"
						[data]="relatorio.postos" />
				</div>
			</div>
		</div>
	</ng-template>
	<seira-card-info aditionalClasses="mt-3" [texto]="descricaoRelatorio" />
</div>
<ng-template #semDados>
	<seira-sem-dados [loading]="carregandoRelatorio" />
</ng-template>
